// extracted by mini-css-extract-plugin
export default {"rowContainer":"InfoTable_rowContainer__rgCka","statistics":"InfoTable_statistics__oPzsm","modalContainer":"InfoTable_modalContainer__yJo8Z"};